var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-modal',{attrs:{"title":_vm.$t('modals.document.deleteTitle'),"action":"delete","on-submit":_vm.submit,"on-close":() => _vm.$emit('close')}},[_c('span',[_vm._v(_vm._s(_vm.$t('modals.document.deleteConfirm')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }